import './style.scss';
import React, { useState, useEffect, useCallback } from 'react';
import useIsMobile from 'pctHooks/useIsMobile';

type OptionValue = {
    index: number;
    value: number | '';
};

const EvaluationKnowCorrelate = ({ optionAnswers, options, selectItemEvent, answerData, viewType }) => {
    const [optionsValue, setOptions] = useState<OptionValue[]>([]);
    const isMobile = useIsMobile();
    const [answerCorret, setAnswerCorret] = useState<
        {
            isCorrect: boolean;
            label: string;
            class: string;
        }[]
    >([]);
    useEffect(() => {
        const values: { index: number; value: number }[] = [];
        answerData.forEach((elem) => {
            const index = options.findIndex((item) => item.idQuestionOption === elem.idQuestionOption);
            values.push({ index: elem.idQuestionOptionAnswer, value: index + 1 });
        });
        setOptions(values);
        if (viewType === 'modalFeed') {
            const _answerCorret: any[] = [];
            optionAnswers.forEach((elem) => {
                const isCorrect = elem.idQuestionOptionAnswer === elem.idQuestionOptionAnswerCorrect;
                let index = 0;
                if (!isCorrect) {
                    index = options.findIndex((item) => item.idQuestionOption === elem.idQuestionOptionChosenCorrect);
                }
                _answerCorret.push({
                    isCorrect,
                    label: isCorrect ? 'Parabéns! Você acertou!' : `Você errou! Resposta: <span class="strong-number">${index + 1}</span> `,
                    class: isCorrect ? 'isCorrectSelected' : 'isErroSelected',
                });
            });
            setAnswerCorret(_answerCorret);
        }
    }, [answerData, options, optionAnswers, viewType]);

    
    const handleChange = useCallback(
        (e: React.ChangeEvent<HTMLInputElement>, optionAnswer, index) => {
            const input = e.target;
            const rawValue = input.value;

            // CLEAR
            if (rawValue === '') {
                const item = {
                    idQuestionOption: null,
                    ...optionAnswer,
                };

                selectItemEvent(false, item, e.timeStamp);

                setOptions((prevState) => prevState.filter((item) => item.index !== index));

                requestAnimationFrame(() => input.blur());
                return;
            }

            const numericValue = Number(rawValue);

            if (isNaN(numericValue) || numericValue <= 0 || numericValue > options.length) {
                return;
            }

            // VALIDAR DUPLICADO ANTES
            const alreadyUsed = optionsValue.find((item) => item.value === numericValue && item.index !== index);

            if (alreadyUsed) {
                requestAnimationFrame(() => input.blur());
                return;
            }

            setOptions((prevState) => {
                const newState = [...prevState];
                const existingIndex = newState.findIndex((item) => item.index === index);

                if (existingIndex > -1) {
                    newState[existingIndex] = { index, value: numericValue };
                } else {
                    newState.push({ index, value: numericValue });
                }

                return newState;
            });

            // Só salva se passou validação
            const item = {
                idQuestionOption: options[numericValue - 1]?.idQuestionOption,
                ...optionAnswer,
            };

            selectItemEvent(true, item, e.timeStamp);
        },
        [options, optionsValue, selectItemEvent],
    );

    const getValue = useCallback((index) => {
        const option = optionsValue.find((elem) => elem.index === index);
        return option?.value || '';
    }, [optionsValue]);
    const optionAnswersComponent = useCallback((optionAnswers, index) => {
        return (
            <div
                key={optionAnswers.idQuestionOptionAnswer}
                className={`line ${answerCorret[index]?.class}`}
            >
                <div className="block">
                    <input
                        id={`alt${index}`}
                        disabled={viewType === 'modalFeed'}
                        placeholder="0"
                        type={'number'}
                        className="d-none input"
                        onChange={(e) => handleChange(e, optionAnswers, optionAnswers.idQuestionOptionAnswer)}
                        value={getValue(optionAnswers.idQuestionOptionAnswer)}
                    />
                    <span className="line-content">
                        {optionAnswers.description}
                        {viewType === 'modalFeed' && (
                            <div className={answerCorret[index]?.isCorrect ? 'box-sucess' : 'box-error'}>
                                <span dangerouslySetInnerHTML={{ __html: answerCorret[index]?.label }}></span>
                            </div>
                        )}
                    </span>
                </div>
            </div>
        );
    }, [answerCorret,  handleChange, getValue, viewType]);
    return (
        <div className="EvaluationKnowCorrelate">
            <div className="box">
                {options.map((option, index) => (
                    <div className="columnCorrrelate" key={option.idQuestionOption}>
                        <div className="line">
                            <div className="block">
                                <div className="circle-number">{index + 1}</div>
                                <span className="line-content">{option.description} </span>
                            </div>
                        </div>
                        {!isMobile && (
                            <>
                                <div className="verticalLine" />
                                {optionAnswersComponent(optionAnswers[index], index)}
                            </>
                        )}
                    </div>
                ))}
                {isMobile && (
                    <>
                        <div className="horizontalLine" />
                        {optionAnswers.map((option, index) => (
                            <div key={option.idQuestionOption} className="columnCorrrelate">
                                {optionAnswersComponent(option, index)}
                            </div>
                        ))}
                    </>
                )}
            </div>
        </div>
    );
};

export default EvaluationKnowCorrelate;
